import { render, staticRenderFns } from "./AccountDeletionDetails.vue?vue&type=template&id=1fbc7f98&"
import script from "./AccountDeletionDetails.vue?vue&type=script&lang=js&"
export * from "./AccountDeletionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports